import React from 'react'
import './style/ForYou.css'

function ForYou() {
    return (
        <div className="forYou">
            hello from for you
        </div>
    )
}

export default ForYou 
